import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { sanitizeCmsHtml } from '@shared/helpers/sanitize-cms-html';

@Pipe({
  name: 'safeResourceUrl',
})
export class SafeResourceUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
  }

  transform(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}

@Pipe({
  name: 'safeHtml',
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(protected sanitized: DomSanitizer) {
  }

  /**
   * AT-9147: treść CMS najemcy przechodzi przez DOMPurify, a dopiero wynik jest oznaczany
   * jako zaufany. Wcześniej bypass obejmował surową treść (stored XSS u każdego odwiedzającego).
   */
  public transform(value: any): any {
    return this.sanitized.bypassSecurityTrustHtml(sanitizeCmsHtml(value));
  }
}
